export default "__VITE_ASSET__Yu_sw7jy__"